
import Button from '@/components/UntitledUI/Button.vue'
import Icon from '@/components/UntitledUI/Icon.vue'

export default {
    components: { Button, Icon },
    middleware: 'hasAgentFeature',
    data () {
        return {
            loading: true,
            loadingTrial: false,
            showSuccessModal: false,
            showEndingModal: true,
            showModal: false,
            isSubmitted: null,
            status: null
        }
    },
    computed: {
        hasAgent () {
            return this.$auth.user?.features?.agent ?? null
        }
    },
    mounted () {
        this.checkSubmitStatus()
    },
    methods: {
        async checkSubmitStatus () {
            await this.$axios.get('/v1/agent-interests')
                .then((response) => {
                    this.loading = false
                    this.isSubmitted = response.data.submitted
                    this.status = response.data.status
                })
                .catch(() => {
                    this.$toast.error(this.$t('general error please try again'))
                })
        },
        async submitInterest () {
            this.loading = true
            await this.$axios.post('/v1/agent-interests')
                .then(() => {
                    this.isSubmitted = true
                })
                .catch(() => {
                    this.$toast.error(this.$t('general error please try again'))
                }).finally(() => {
                    this.loading = false
                })
        },
        redirect (lang = 'en') {
            this.$router.push(this.localePath('/Search', lang))
        },
        fetchAndRedirect () {
            this.$auth.fetchUser().then(() => this.redirect())
            this.showEndingModal = false
        }
    },
    head () {
        return {
            title: 'جرب قانونية AI'
        }
    }
}
